import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {DiffEntryDataWithExtraInfo} from '../types/commit-types'
import {useEffect, useState} from 'react'

interface ExtraDiffType {
  extraDiffEntries: DiffEntryDataWithExtraInfo[]
  loading: boolean
}

const baseEmptyStateLoading = {extraDiffEntries: [], loading: true}
const baseEmptyStateNotLoading = {extraDiffEntries: [], loading: false}

export function useLoadDeferredDiffs(
  byteCount: number,
  lineShownCount: number,
  startIndex: number,
  url: string,
  shouldSendRequest: boolean,
): ExtraDiffType {
  const [state, setState] = useState<ExtraDiffType>(baseEmptyStateLoading)

  useEffect(() => {
    if (!url || !shouldSendRequest) return

    let cancelled = false
    const update = async () => {
      setState(baseEmptyStateLoading)
      const response = await verifiedFetchJSON(
        `${url}?start_entry=${startIndex}&bytes=${byteCount}&lines=${lineShownCount}`,
      )

      if (cancelled) {
        return
      }

      try {
        if (response.ok) {
          const data = await response.json()
          data.loading = false
          if (data) {
            setState(data)
          }
        } else {
          setState(baseEmptyStateNotLoading)
        }
      } catch (e) {
        setState(baseEmptyStateNotLoading)
      }
    }

    update()

    return function cancel() {
      cancelled = true
    }
  }, [byteCount, lineShownCount, shouldSendRequest, startIndex, url])

  return state
}
